import React from "react";
import styled from "styled-components";
import MainLayout from "../../component/atoms/layout/mainLayout";
import PretendardText from "../../component/atoms/text/pretendardText";
import Header from "../../component/organisms/header";
import Sidebar from "../../component/organisms/sidebar";

const HomeEmpty = () => {
  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        {/* 본문 헤더 영역 */}
        <HomeWrapper>
          <HomeHeader>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <PretendardText
                style={{
                  color: "#b5b5b5",
                  fontSize: "20px",
                  fontWeight: "600",
                  lineHeight: "34px",
                  letterSpacing: "-0.06px",
                }}
              >
                Welcome!
              </PretendardText>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <PretendardText
                  style={{
                    color: "#aaa",
                    fontSize: "40px",
                    fontWeight: "700",
                    lineHeight: "56px",
                    letterSpacing: "-0.28px",
                  }}
                >
                  안녕하세요. 관리자님 :)
                </PretendardText>
              </div>
            </div>
          </HomeHeader>
        </HomeWrapper>
      </MainLayout>
    </>
  );
};

export default HomeEmpty;

const HomeWrapper = styled.div.attrs((props) => {})`
  width: 1044px;
  height: auto;
  margin-top: 190px;
`;

const HomeHeader = styled.div.attrs((props) => {})`
  width: 1044px;
  height: 90px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 40px;
`;
